import { ButtonBase, Card, Divider, Grid, List } from "@mui/material";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import FieldsCard from "../../Components/Cards/FieldsCard";
import MDButton from "../../Components/MDButton";
import MDDragable from "../../Components/Dragable";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FieldModel } from "../../Api/Models/FieldModel";
import { ErrorToaast, SuccessToaast } from "../../utils/toast/Toast";
import { allParamsAction } from "../../Context/redux/actions";
import ApiResponse from "../../Types/Api/Response";
import FieldDto from "../../Types/Api/DTO/FieldDto";
import MDTypography from "../../Components/MDTypography";
import AppLoading from "../../Components/MDLoading";
import CloseIcon from "@mui/icons-material/Close";
import * as Yup from "yup";
import { useFormik } from "formik";
import MDInput from "../../Components/MDInput";

const validationSchema = Yup.object().shape({
  title: Yup.string().required("عنوان الزامی است "),
});
export default function ParametrsPage() {
  const [open, setOpen] = useState<boolean>(false);
  const [Counter, setCounter] = useState<number>(0);
  const [newCard, setNewCard] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const [deleteParams, setDeleteParams] = useState<{
    id: number;
    name: string;
  } | null>(null);
  const dispatch = useDispatch();
  let allParams: FieldDto[] = useSelector((state: any) => state.allParams);
  let fieldModel = new FieldModel();
  useEffect(() => {
    fieldModel
      .getAll()
      .then(async (r) => {
        var response: ApiResponse<FieldDto[]> = r.data;
        await dispatch(allParamsAction(response.data));
        setLoading(false);
      })
      .catch((e) => ErrorToaast("مشکل در برقراری ارتباط"));

    return () => {
      dispatch(allParamsAction([]));
      setOpen(false);
      setNewCard(false);
      formik.resetForm();
    };
  }, [Counter]);

  const handleDelete = async () => {
    if (deleteParams) {
      setLoading(true);

      await fieldModel
        .delete(deleteParams.id)
        .then(() => {
          setCounter((counter) => counter + 1);
          setLoading(false);
          SuccessToaast("با موفقیت حذف شد");
        })
        .catch(() => {
          ErrorToaast("با مشکل مواجه شد ");
        });
    }
    setLoading(false);
    setOpen(false);
  };
  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      edit: false,
      id: 0,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      var model = {
        Name: values.title,
        Description: values.description,
        id: 0,
      };
      if (values.edit) {
        model.id = values.id;
        await fieldModel
          .update(values.id, model)
          .then((r) => {
            setCounter((c) => c + 1);
            setLoading(false);
            setNewCard(false);
            SuccessToaast("با موفقیت انجام شد");
          })
          .catch((r) => {
            ErrorToaast("با مشکل مواجه شد");
          });
      } else {
        await fieldModel
          .crete(model)
          .then((r) => {
            setCounter((c) => c + 1);
            setLoading(false);
            setNewCard(false);
            SuccessToaast("با موفقیت انجام شد");
          })
          .catch((r) => {
            ErrorToaast("با مشکل مواجه شد");
          });
      }
    },
  });
  useEffect(() => {
    return () => {
      setOpen(false);
      setNewCard(false);
      formik.resetForm();
    };
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar name={"پارامتر ها"}>
        <MDBox>
          <MDButton
            variant="outlined"
            color="secondary"
            onClick={() => {
              if (formik.values.edit === true) {
                formik.resetForm();
              } else {
                setNewCard((state) => !state);
              }
              window.scroll(0, 0);
            }}
            fullWidth
          >
            افزودن
          </MDButton>
        </MDBox>
      </DashboardNavbar>
      {newCard && (
        <>
          <Grid container spacing={3} justifyContent={"center"}>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox sx={{ height: "calc(100% - 12px)" }} mb={1.5}>
                <Card sx={{ height: "100%" }}>
                  <MDBox display="flex" pt={1} px={2}>
                    <MDBox textAlign="right" lineHeight={1.25} width={"100%"}>
                      <Grid container justifyContent={"space-between"} alignContent={"center"}>
                        <Grid item>
                          <MDTypography variant="h5" fontWeight="light" color="dark" ml={1}>
                            {formik.values.edit ? "ویرایش" : "افزودن"}
                          </MDTypography>
                        </Grid>
                        <Grid item container width={"unset"}>
                          <ButtonBase
                            onClick={() => {
                              formik.resetForm();
                              setNewCard(false);
                            }}
                          >
                            <CloseIcon fontSize="medium" />
                          </ButtonBase>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                  <Divider />
                  <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
                    <MDBox sx={{ margin: "0 20px" }}>
                      <MDInput
                        type="username"
                        name="title"
                        onChange={formik.handleChange}
                        error={formik.touched.title && Boolean(formik.errors.title)}
                        helperText={formik.touched.title && formik.errors.title}
                        disabled={loading}
                        label="عنوان"
                        fullWidth
                        value={formik.values.title}
                      />
                    </MDBox>
                    <Divider />
                    <MDBox sx={{ margin: "0 20px" }}>
                      <MDInput
                        type="username"
                        name="description"
                        onChange={formik.handleChange}
                        error={formik.touched.description && Boolean(formik.errors.description)}
                        helperText={formik.touched.description && formik.errors.description}
                        disabled={loading}
                        label="توضیحات"
                        fullWidth
                        multiline
                        value={formik.values.description}
                      />
                    </MDBox>
                    <Divider />
                    <MDBox pb={2} px={2}>
                      <Grid container spacing={3}>
                        <Grid item xs={12} md={12} lg={12}>
                          <MDBox>
                            <MDButton variant="gradient" color="success" type="submit" fullWidth>
                              ثبت
                            </MDButton>
                          </MDBox>
                        </Grid>
                      </Grid>
                    </MDBox>
                  </MDBox>
                </Card>
              </MDBox>
            </Grid>
          </Grid>
          <Divider />
        </>
      )}
      <MDDragable
        open={open}
        setOpen={setOpen}
        title="حذف پارامتر"
        desciption={`ایا از حذف ${deleteParams?.name} اطمینان دارید ؟`}
        buttons={
          <Grid container justifyContent={"flex-start"}>
            <MDButton onClick={handleDelete}>تایید</MDButton>
            <MDButton autoFocus onClick={() => setOpen(false)}>
              بستن
            </MDButton>
          </Grid>
        }
      />

      <MDBox py={3}>
        <Grid container spacing={3} justifyContent={"center"}>
          {allParams.length < 1 && (
            <Grid container item xs={12} md={11} lg={10}>
              <Card sx={{ width: "100%" }}>
                <MDBox display="flex" justifyContent="center" alignItems="center" p={3}>
                  <MDTypography>هیچ پارامتری ثبت نشده است.</MDTypography>
                </MDBox>
              </Card>
            </Grid>
          )}
          {allParams.length > 0 &&
            allParams
              .map((e: FieldDto) => {
                return (
                  <Grid key={e.key} item xs={12} md={6} lg={3}>
                    <MDBox sx={{ height: "calc(100% - 12px)" }} mb={1.5}>
                      <FieldsCard
                        editButton={
                          <MDButton
                            variant="gradient"
                            color="secondary"
                            onClick={() => {
                              formik.setFieldValue("title", e.name, true);
                              formik.setFieldValue("description", e.description);
                              formik.setFieldValue("edit", true);
                              formik.setFieldValue("id", e.id);
                              window.scrollTo(0, 0);
                              setNewCard(true);
                            }}
                            fullWidth
                          >
                            ویرایش
                          </MDButton>
                        }
                        deleteButton={
                          <MDButton
                            variant="gradient"
                            color="error"
                            onClick={() => {
                              setOpen(true);
                              setDeleteParams({ id: e.id, name: e.name });
                            }}
                            fullWidth
                          >
                            حذف
                          </MDButton>
                        }
                        color="info"
                        rowNumber={e.id.toString()}
                        title={e.name}
                        description={e.description}
                      />
                    </MDBox>
                  </Grid>
                );
              })}
        </Grid>
      </MDBox>
      <AppLoading show={loading} />
    </DashboardLayout>
  );
}
